import { AxiosResponse } from 'axios';
import { axios } from '@repository/RequestClient';
import MatchingAchievementLogSaveRq from '@domain/rq/match/MatchingAchievementLogSaveRq';

export default interface Logging {
  // 인재풀 성과 로깅 저장
  saveMatchingAchievementLog(rq: MatchingAchievementLogSaveRq): Promise<AxiosResponse>;
}

export class RemoteLogging implements Logging {
  saveMatchingAchievementLog(rq: MatchingAchievementLogSaveRq) {
    return axios.post('/match/achievement-logs', rq);
  }
}
